import { File, Paths } from 'expo-file-system';
import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import { shareAsync } from 'expo-sharing';
import { MyVaroContext } from 'features/myVaro/provider/MyVaroContextProvider';
import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';
import IconButton from 'shared/components/vxl/icon/IconButton/IconButton';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import { logBreadcrumb } from 'shared/utils/sentry/sentry';

const TaxStatementPDF = () => {
  const router = useRouter();
  const {
    taxYearSelectionScreenTitle,
    taxStatementPDFId,
    setTaxStatementPDFId,
    taxStatementPDFTitle,
    setTaxStatementPDFTitle,
  } = useContext(MyVaroContext);

  const onShare = async () => {
    try {
      if (taxStatementPDFId) {
        const destination = new File(
          Paths.cache,
          `${taxStatementPDFTitle}.pdf`,
        );
        const downloadedFile = await File.downloadFileAsync(
          taxStatementPDFId,
          destination,
          { idempotent: true },
        );
        await shareAsync(downloadedFile.uri);
      }
    } catch (error) {
      logBreadcrumb({
        level: 'error',
        message: 'TaxStatementPDF onShare error: ' + error,
      });
    }
  };

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          title: taxYearSelectionScreenTitle,
          headerShown: true,
          headerBackVisible: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              primaryOnPress={() => {
                setTaxStatementPDFId?.('');
                setTaxStatementPDFTitle?.('');
                router.back();
              }}
              trailingAccessories={
                <IconButton
                  iconKey="SHARE"
                  iconButtonAccessibilityLabel="SHARE"
                  iconOnPress={onShare}
                />
              }
            />
          ),
        }}
      />
      {taxStatementPDFId ? <PdfViewer url={taxStatementPDFId} /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexGrow: 1,
  },
});

export default TaxStatementPDF;
